import React, { useContext, useEffect, useState, FC } from 'react';
import ContentSignatureContext from '../contexts/ContentSignatureContext';
import { Platform } from 'react-native';
import { lambdaUrl } from '../api';

export const ContentSignatureProvider: FC = ({ children }) => {
  const [contentSignature, setContentSignature] = useState('');
  const [contentSignatureError, setContentSignatureError] = useState<string>();
  const [contentSignatureLoading, setContentSignatureLoading] = useState(
    Platform.OS === 'web',
  );

  const getContentSignature = async () => {
    if (Platform.OS !== 'web') {
      setContentSignatureLoading(false);
      return null;
    }

    try {
      const resp = await fetch(`${lambdaUrl}/sign`, {
        method: 'GET',
        cache: 'no-store',
      });
      const data = await resp.json();
      if (!resp.ok || !data?.params) {
        throw new Error('Unable to load content signature');
      }

      setContentSignature(`?${data?.params}`);
      setContentSignatureError(undefined);
    } catch (e) {
      const message = e.message || 'Unable to load content signature';
      console.error(message);
      setContentSignatureError(message);
    } finally {
      setContentSignatureLoading(false);
    }
  };

  useEffect(() => {
    getContentSignature();
  }, []);

  return (
    <ContentSignatureContext.Provider
      value={{
        contentSignature,
        contentSignatureError,
        contentSignatureLoading,
      }}
    >
      {children}
    </ContentSignatureContext.Provider>
  );
};

export const useContentSignature = () => useContext(ContentSignatureContext);
